// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"228":"f99d989c","405":"375670a7","432":"c1ede7df","443":"e3067fd0","459":"ee072964","520":"530a86f0","608":"07293f2f","711":"870ae2a9","715":"e894b4c5","888":"3e64125a","983":"bffe944f"}[chunkId] + ".js";
};